import { styled } from "@mui/material/styles";
import { SPACING } from "../palette";
const GRID_GUTTER = SPACING.spacexss;
const Container = styled("div")(() => ({
    "margin": "0px auto",
    "maxWidth": "75.00rem",
    "paddingInline": GRID_GUTTER
}));
const ContainerStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.common.white,
    "paddingBlock": SPACING.space2xl
}));
const ContainerCozy = styled("div")(() => ({
    "margin": "0px auto",
    "maxInlineSize": "calc(77.05rem * .65)",
    "paddingInline": GRID_GUTTER
}));
const RowStyle = styled("div")(({ theme }) => ({
    "--space": SPACING.spacexss,
    ">*": {
        "flex": "1 0 20rem"
    },
    "color": theme.palette.common.black,
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "var(--space , clamp(0.75rem, calc(0.57rem + 0.88vw), 1.25rem))"
}));
export { Container, ContainerCozy, ContainerStyle, GRID_GUTTER, RowStyle };
